import {
  CustomerCheckoutListItem,
  CustomerOrderListItem,
} from '@ancon/wildcat-types'
import { createEntityAdapter } from '@reduxjs/toolkit'

import { CheckOrderTicketEntity } from '../types'

const activeOrdersEntityAdapter =
  createEntityAdapter<CustomerCheckoutListItem>()

const upcomingOrdersEntityAdapter =
  createEntityAdapter<CustomerCheckoutListItem>()

const pastOrdersEntityAdapter = createEntityAdapter<CustomerOrderListItem>()

const checkOrderTicketsEntityAdapter =
  createEntityAdapter<CheckOrderTicketEntity>()

export {
  activeOrdersEntityAdapter,
  pastOrdersEntityAdapter,
  upcomingOrdersEntityAdapter,
  checkOrderTicketsEntityAdapter,
}
